import React, { useState, useEffect } from "react";
import HeroSection from "../components/HeroSection";
import Navigation from "../components/Navigation";
import AboutSection from "../components/AboutSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const HomePage = ({ nightMode, setNightMode }) => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "about", "contact"];
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="homepage">
      <HeroSection nightMode={nightMode} setNightMode={setNightMode} />
      <AboutSection nightMode={nightMode} />
      <ContactSection nightMode={nightMode} />
      <Footer nightMode={nightMode} />
      <Navigation activeSection={activeSection} onNavigate={scrollToSection} nightMode={nightMode} />
    </div>
  );
};

export default HomePage;
